import type { useForm } from "hooks";
import type { BootstrapableForm } from "types";
import type { OnboardingFormProps } from "ui/forms/ECommerce/Onboarding/types";
import type { HighRiskMerchant } from "features/ecommerce/types";
import type { DocumentIdentity } from "./entities";

export const enum DocumentField {
    DocumentFileKey = 'documentFileKey'
}

export const enum FormField {
    CertificateOfIncorporation = 'certificateOfIncorporation',
    MemorandumAndArticles = 'memorandumAndArticles',
    CompanyAccountBankStatement = 'companyAccountBankStatement',
    CompanyFinancialStatement = 'companyFinancialStatement',
    BankReference = 'bankReference',
    CopyOfLicences = 'copyOfLicences',
    ProofOfDomainOwnership = 'proofOfDomainOwnership',
    PassportsOfShareholders = 'passportsOfShareholders',
    UtilityBillOfShareholders = 'utilityBillOfShareholders',
    OfficialCompanyDocWithAuthority = 'officialCompanyDocWithAuthority',
    StructureChart = 'structureChart'
};

export type ClientDocument = DocumentIdentity;

export type OnboardingUploadDocuments = Record<HighRiskMerchant.Document['documentType'], Array<ClientDocument>>;

export type OnboardingUploadDocumentsBootstrapData = {};

export type OnboardingUploadDocumentsForm = Omit<
    BootstrapableForm<OnboardingUploadDocuments, OnboardingUploadDocumentsBootstrapData>,
    | 'initialValues'
> & {
    readonly initialValues: OnboardingUploadDocuments;
};

export type OnboardingUploadDocumentsProps =
    & OnboardingFormProps
    & OnboardingUploadDocumentsForm
    & ReturnType<typeof useForm<OnboardingUploadDocuments>>;
